import React from "react";
var __jsx = React.createElement;
import { createContext, useContext, useEffect, useState } from "react";
import { checkCarConditionHelper } from "@/pages/post/helpers/postHelpers";
var PostDetailsContext = /*#__PURE__*/createContext(null);
export function usePostDetails() {
  return useContext(PostDetailsContext);
}
export var PostDetailsContextProvider = function PostDetailsContextProvider(_ref) {
  var children = _ref.children;
  var _useState = useState(),
    postDetails = _useState[0],
    setPostDetails = _useState[1];
  var _useState2 = useState("unknown"),
    carCondition = _useState2[0],
    setCarCondition = _useState2[1];
  useEffect(function () {
    setCarCondition(checkCarConditionHelper(postDetails));
  }, [checkCarConditionHelper(postDetails)]);
  return /*#__PURE__*/React.createElement(PostDetailsContext.Provider, {
    value: {
      setPostDetails: setPostDetails,
      postDetails: postDetails,
      carCondition: carCondition
    }
  }, children);
};
export default PostDetailsContext;